export default __webpack_public_path__ + "static/media/sandiego5.cfcf926a.jpeg";